import { GeneratedCustomReportItemIdentity } from './generated-custom-report-item.identity';

export class CustomReportItemIdentity extends GeneratedCustomReportItemIdentity {

}
